var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.083 10.316L13.4788 9.12268L18.6696 19.5638L14.8763 18.1717L11.083 10.316Z",
    fill: "#F98586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53711 11.559L10.8331 10.4154L14.8759 18.1717L13.7279 22.0001L8.53711 11.559Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2354 10.7634L11.8325 9.9679L16.1249 18.6191L14.8771 18.1717L14.5278 19.4146L10.2354 10.7634Z",
    fill: "#C10655"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58659 10.3161L5.19082 9.1228L0 19.5639L3.74338 18.1718L7.58659 10.3161Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.082 11.559L7.78602 10.4154L3.74316 18.1717L4.94105 22.0001L10.082 11.559Z",
    fill: "#F98586"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43548 10.7635L6.83831 9.96802L2.5459 18.6193L3.74378 18.1718L4.14307 19.4148L8.43548 10.7635Z",
    fill: "#C10655"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33269 0.32251C10.0315 0.32251 10.0814 1.41634 10.6803 1.51578C11.2792 1.66494 11.978 0.819707 12.4771 1.01859C13.126 1.3169 12.6768 2.3113 13.1759 2.70906C13.675 3.10681 14.6732 2.60962 15.0226 3.0571C15.4718 3.60401 14.6732 4.30009 14.9228 4.84701C15.1724 5.39392 16.3203 5.39392 16.4701 5.94084C16.6198 6.5872 15.5717 6.88551 15.5717 7.53187C15.5717 8.12851 16.5699 8.6257 16.4701 9.17262C16.3203 9.81898 15.2722 9.66982 14.9727 10.2167C14.7232 10.7637 15.4219 11.6586 15.0226 12.1061C14.6233 12.653 13.7249 12.0066 13.2258 12.4044C12.7267 12.8022 12.9762 13.896 12.4771 14.1446C11.8782 14.4429 11.3292 13.4982 10.7302 13.6474C10.1313 13.7966 9.88172 14.8904 9.28277 14.8904C8.58401 14.8904 8.5341 13.7966 7.93516 13.6971C7.33622 13.548 6.63745 14.4429 6.08842 14.1943C5.48948 13.896 5.88877 12.9016 5.38966 12.5038C4.89054 12.1061 3.8923 12.6033 3.54292 12.1558C3.14363 11.6089 3.94222 10.9128 3.64275 10.3659C3.49301 9.76926 2.34504 9.76926 2.1953 9.22234C2.04557 8.57598 3.09372 8.27767 3.09372 7.63131C3.09372 7.03467 2.09548 6.53748 2.1953 5.99056C2.34504 5.3442 3.39319 5.49336 3.69266 4.94644C3.99213 4.39953 3.29336 3.50457 3.64275 3.0571C4.04204 2.51018 4.94045 3.15653 5.43957 2.75878C5.93869 2.36102 5.68913 1.26718 6.18825 1.01859C6.78719 0.720268 7.33622 1.66494 7.93516 1.51578C8.48419 1.41634 8.73375 0.32251 9.33269 0.32251Z",
    fill: "#FFDF66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33329 12.7027C12.1783 12.7027 14.4742 10.4156 14.4742 7.58158C14.4742 4.74756 12.1783 2.46045 9.33329 2.46045C6.48832 2.46045 4.19238 4.74756 4.19238 7.58158C4.19238 10.4156 6.48832 12.7027 9.33329 12.7027Z",
    fill: "#FFC63B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33341 12.3048C11.9288 12.3048 14.075 10.1668 14.075 7.58141C14.075 4.99598 11.9288 2.85803 9.33341 2.85803C6.738 2.85803 4.5918 4.99598 4.5918 7.58141C4.5918 10.1668 6.738 12.3048 9.33341 12.3048Z",
    fill: "#FFDF66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.1599,
    cy: 7.75023,
    r: 4.91349,
    fill: "url(#paint0_linear)",
    stroke: "white",
    strokeWidth: 0.608051
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2835 9.31068C10.3789 9.31068 10.4543 9.33741 10.5097 9.39086C10.565 9.4424 10.5927 9.51112 10.5927 9.59702V10.1124H7.66061V9.82609C7.66061 9.77073 7.67206 9.71155 7.69497 9.64856C7.71788 9.58557 7.75796 9.5283 7.81523 9.47676L9.01785 8.26555C9.12093 8.16247 9.21065 8.06416 9.287 7.97063C9.36336 7.87709 9.42635 7.78546 9.47599 7.69574C9.52562 7.60411 9.56284 7.51344 9.58766 7.42372C9.61247 7.33209 9.62488 7.23569 9.62488 7.13452C9.62488 6.96845 9.58479 6.8415 9.50462 6.75369C9.42635 6.66397 9.30609 6.61912 9.14384 6.61912C9.01212 6.61912 8.90045 6.65443 8.80882 6.72506C8.7191 6.79378 8.65706 6.87968 8.6227 6.98276C8.58261 7.08775 8.53012 7.15743 8.46522 7.19179C8.40031 7.22615 8.30773 7.23379 8.18747 7.2147L7.71788 7.13166C7.74842 6.92359 7.80664 6.74224 7.89254 6.58762C7.98035 6.433 8.08821 6.30414 8.2161 6.20106C8.34591 6.09798 8.49385 6.02163 8.65993 5.97199C8.826 5.92045 9.00448 5.89468 9.19538 5.89468C9.40154 5.89468 9.5867 5.92523 9.75087 5.98631C9.91695 6.04549 10.0582 6.12852 10.1746 6.23542C10.2911 6.34232 10.3799 6.47022 10.4409 6.61912C10.5039 6.7661 10.5354 6.92836 10.5354 7.10589C10.5354 7.2586 10.5135 7.39986 10.4696 7.52967C10.4276 7.65947 10.3694 7.78355 10.2949 7.90191C10.2205 8.01835 10.1336 8.13193 10.0343 8.24265C9.93699 8.35145 9.83295 8.46217 9.72224 8.5748L8.90618 9.4109C9.01117 9.37845 9.1152 9.35363 9.21828 9.33645C9.32136 9.31927 9.41681 9.31068 9.50462 9.31068H10.2835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 6.44405,
    y: 5.2866,
    width: 5.3643,
    height: 6.64995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.608051
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.608051
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.1599,
    y1: 2.53271,
    x2: 9.1599,
    y2: 12.9678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyRank2);
export default __webpack_public_path__ + "static/media/trophy-rank-2.acdd96b6aa94bfa0633430b0aab3774d.svg";
export { ForwardRef as ReactComponent };